import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img 
              src="https://funaffairs.com/wp-content/uploads/2022/11/logo.png" 
              alt="Fun Affairs" 
              className="h-12 w-auto"
            />
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            <Link to="/" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/') ? 'text-red-600' : isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'}`}>
              Home
            </Link>
            <Link to="/services" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/services') ? 'text-red-600' : isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'}`}>
              Services
            </Link>
            <Link to="/about" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/about') ? 'text-red-600' : isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'}`}>
              About
            </Link>
            <Link to="/service-areas" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/service-areas') ? 'text-red-600' : isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'}`}>
              Service Areas
            </Link>
            <Link to="/reviews" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/reviews') ? 'text-red-600' : isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'}`}>
              Reviews
            </Link>
            <Link to="/faq" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/faq') ? 'text-red-600' : isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'}`}>
              FAQ
            </Link>
            <Link to="/contact" className={`text-sm font-medium transition-colors whitespace-nowrap ${isActive('/contact') ? 'text-red-600' : isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-white hover:text-red-400'}`}>
              Contact
            </Link>
          </nav>

          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:6102532835" className={`flex items-center space-x-2 text-sm font-semibold whitespace-nowrap ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              <i className="ri-phone-fill text-lg"></i>
              <span>(610) 253-2835</span>
            </a>
            <Link to="/contact" className="bg-red-600 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-red-700 transition-colors whitespace-nowrap">
              Get Free Quote
            </Link>
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2"
            aria-label="Toggle menu"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t">
          <nav className="px-4 py-4 space-y-3">
            <Link to="/" className="block py-2 text-sm font-medium text-gray-900 hover:text-red-600" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
            <Link to="/services" className="block py-2 text-sm font-medium text-gray-900 hover:text-red-600" onClick={() => setIsMobileMenuOpen(false)}>Services</Link>
            <Link to="/about" className="block py-2 text-sm font-medium text-gray-900 hover:text-red-600" onClick={() => setIsMobileMenuOpen(false)}>About</Link>
            <Link to="/service-areas" className="block py-2 text-sm font-medium text-gray-900 hover:text-red-600" onClick={() => setIsMobileMenuOpen(false)}>Service Areas</Link>
            <Link to="/reviews" className="block py-2 text-sm font-medium text-gray-900 hover:text-red-600" onClick={() => setIsMobileMenuOpen(false)}>Reviews</Link>
            <Link to="/faq" className="block py-2 text-sm font-medium text-gray-900 hover:text-red-600" onClick={() => setIsMobileMenuOpen(false)}>FAQ</Link>
            <Link to="/contact" className="block py-2 text-sm font-medium text-gray-900 hover:text-red-600" onClick={() => setIsMobileMenuOpen(false)}>Contact</Link>
            <a href="tel:6102532835" className="block py-2 text-sm font-semibold text-red-600">
              <i className="ri-phone-fill"></i> (610) 253-2835
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}